import axios from 'axios';
import {customStore} from 'reducer/store'
import { Cookies } from "react-cookie";

const cookies = new Cookies();
const { dispatch } = customStore
let debounce;

const axiosInstance = axios.create({
    // baseURL: `${process.env.REACT_APP_API}`,
    timeout: 30000,
})

axiosInstance.interceptors.request.use((config) => {
    return config;
})

axiosInstance.interceptors.response.use((config) => {
   
    clearTimeout(debounce);
    
    const code = config?.data?.code;
    const sessionData = config?.data?.data?.sessionData;
    const serverTime = config.data.serverTime? config.data.serverTime : new Date()
    
    let tmout = 0;

    if(sessionData) {
        tmout = sessionData?.sessionMaxTime;
        cookies.set("bpl_login", `${new Date().toISOString()}|${tmout}`,{path: "/"})
    }
    debounce = setTimeout(() => {dispatch({type: "SET_SERVERTIME", serverTime: serverTime?.split(".")?.[0]+".000+00:00"})}, 500);
    if (code === '401' && config?.config?.url !== "/api/session/check") {
        window.location.replace("/login");
    } else if(code === "403") {
        window.location.replace("/noauth")
    }
    
    return config;
})

export default axiosInstance;